// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import { SECTION_MODE } from '../../../container/SinglePageCheckout.constants';
import SectionHeader from '../../common/SectionHeader';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPickup,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const PickupHeader = (props) => {
  const {
    section,
    handleEdit,
    handleCancel,
    updateSectionState,
    pickUpContactPerson,
    isPlccIC,
    pageCategory,
    bossSwitchEnabled,
    onPickUpOpenClick,
  } = props;
  const globalActionsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACTIONS_LABELS,
    GlobalActionsLabels
  );
  const { disabled, isExpanded } = section || {};
  const haveFirstName = !isPlccIC && pageCategory !== 'bagPage' && !!pickUpContactPerson?.firstName;
  const showEditCTA = haveFirstName && section.mode === SECTION_MODE.SECTION_VIEW_MODE;
  const actionLabel = showEditCTA
    ? renderLabel(globalActionsLabels.lbl_edit, 'lbl_edit')
    : renderLabel(globalActionsLabels.lbl_cancel, 'lbl_cancel');

  return (
    <SectionHeader
      disabled={disabled}
      handleOnClick={() => {
        if (!haveFirstName) {
          updateSectionState({ isExpanded: !isExpanded });
        }
      }}
      headerIcon="marker-icon"
      headerAltLabel="Pickup"
      headerDataLocator="markerIcon"
      heading={getLabelFromCopyOrFromTranslation(
        `${GLOBAL_GENERIC_LABELS}.${lblPickup}`,
        GlobalGenericLabels
      )}
      headingDataLocator="pickupHdr"
      showAction={haveFirstName}
      actionClassName="underline"
      actionLabel={actionLabel}
      actionAriaLabel={actionLabel}
      actionDataLocator={showEditCTA ? 'editPickup' : 'cancelEditPickup'}
      handleOnActionClick={showEditCTA ? handleEdit : handleCancel}
      bossSwitchEnabled={bossSwitchEnabled}
      onPickUpOpenClick={onPickUpOpenClick}
      {...props}
    />
  );
};

PickupHeader.propTypes = {
  section: PropTypes.shape({}).isRequired,
  savedAddress: PropTypes.shape({}),
  handleEdit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  updateSectionState: PropTypes.func.isRequired,
};

PickupHeader.defaultProps = {
  savedAddress: {},
};

export default PickupHeader;
